// extracted by mini-css-extract-plugin
export var currencyInput = "_jj-1";
export var currencySymbol = "_jj-0";